










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class SortIcon extends Vue {
  @Prop(Boolean) descending!: boolean;
}
